"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _intlTelInput = _interopRequireDefault(require("intl-tel-input"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styleModule = _interopRequireDefault(require("../Input/style.module.css"));

require("./intlTelInput.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PhoneField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PhoneField, _React$Component);

  function PhoneField(props) {
    var _this;

    _classCallCheck(this, PhoneField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PhoneField).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "changeCountryCode", function (e) {
      var _this$props = _this.props,
          name = _this$props.name,
          onCountryCodeChange = _this$props.onCountryCodeChange;

      var _this$phoneFiled$getS = _this.phoneFiled.getSelectedCountryData(),
          dialCode = _this$phoneFiled$getS.dialCode;

      var hiddenField = _this.container.current.querySelector("input[name=".concat(name, "_country_code]"));

      hiddenField.value = dialCode;
      onCountryCodeChange(dialCode);
    });

    _defineProperty(_assertThisInitialized(_this), "setCountryCode", function (countryCode) {
      var countryData = window.intlTelInputGlobals.getCountryData();
      var name = _this.props.name;
      var selectedCountry = countryData.filter(function (i) {
        return i.dialCode === countryCode;
      });

      if (selectedCountry && selectedCountry.length > 0) {
        var selected = selectedCountry[0];

        _this.phoneFiled.setCountry(selected.iso2);

        var hiddenField = _this.container.current.querySelector("input[name=".concat(name, "_country_code]"));

        hiddenField.value = selected.dialCode;
      }
    });

    _this.state = {
      phoneNumber: props.value,
      countryCode: props.countryCode ? props.countryCode : "91"
    };
    _this.phoneFieldRef = _react.default.createRef();
    _this.container = _react.default.createRef();
    _this.phoneFiled = null;
    return _this;
  }

  _createClass(PhoneField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          onPhoneChange = _this$props2.onPhoneChange;
      var countryCode = this.state.countryCode;
      this.phoneFiled = (0, _intlTelInput.default)(this.phoneFieldRef.current, {
        initialCountry: "in",
        separateDialCode: true,
        preferredCountries: ["in", "lk", "us", "uk"],
        customContainer: "intl__phone__number__container",
        formatOnDisplay: false,
        hiddenInput: "".concat(name, "_country_code"),
        dropdownContainer: this.container.current
      });

      if (countryCode) {
        this.setCountryCode(countryCode);
      }

      this.phoneFieldRef.current.addEventListener("countrychange", this.changeCountryCode);
      this.phoneFieldRef.current.addEventListener('keyup', onPhoneChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value || this.props.countryCode !== prevProps.countryCode) {
        this.setState({
          phoneNumber: this.props.value,
          countryCode: this.props.countryCode
        });
        this.setCountryCode(this.props.countryCode);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          name = _this$props3.name,
          id = _this$props3.id,
          placeholder = _this$props3.placeholder,
          className = _this$props3.className,
          required = _this$props3.required,
          parentClassName = _this$props3.parentClassName;
      var phoneNumber = this.state.phoneNumber;
      return _react.default.createElement("div", {
        ref: this.container,
        className: parentClassName || "",
        style: {
          position: "relative"
        }
      }, _react.default.createElement("input", {
        ref: this.phoneFieldRef,
        type: "tel",
        name: name,
        id: id,
        defaultValue: phoneNumber,
        className: "".concat(_styleModule.default.input, " ").concat(className),
        placeholder: placeholder,
        required: required
      }));
    }
  }]);

  return PhoneField;
}(_react.default.Component);

PhoneField.defaultProps = {
  id: "",
  value: "",
  className: "",
  placeholder: "",
  required: false
};
PhoneField.propTypes = {
  name: _propTypes.default.string.isRequired,
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  value: _propTypes.default.string,
  required: _propTypes.default.bool,
  placeholder: _propTypes.default.string
};
var _default = PhoneField;
exports.default = _default;